<template>
  <div class="p-0">
    <!-- Affichage d'une barre de progression pendant le chargement des données -->
    <load-progress :condition="!dataLoaded" :label="'Chargement des données'">
    </load-progress>

     <v-bottom-navigation v-if="dataLoaded && isMobile" fixed >
        <v-col class="d-flex align-center" v-for="(module, index) in navigationItems" :key="index">
          <div @click="pushModuleRoute(module)">
            <v-img :class="getClass(module)"></v-img>
          </div>
        </v-col>

      </v-bottom-navigation>
  </div>
</template>

<script lang="ts">
import LoadProgress from '@/framework/base/components/LoadProgress.vue';
import { storeSession } from '@/generated/stores';
import { isMobile } from '@/style/StyleHelpers';
import { goToModule } from '@/framework/base/helpers/NavHelper';
import { NavigationItem } from '@/framework/base/classes/NavigationItem';
import { defineComponent, type PropType } from "vue";
import {useRoute, useRouter} from "vue-router";

export default defineComponent({
  components: {
    LoadProgress,
  },
  props: {
    navigationItems: {
      type: Array as PropType<NavigationItem[]>,
      required: true
    }
  },
  data() {
    return {
      isMobile: isMobile(),
      selectedItem: new NavigationItem(),
      router: useRouter(),
      route: useRoute()
    };
  },
  computed: {
    dataLoaded(): boolean {
      const res = storeSession.sessionValid || !storeSession.loginOut;
      if (res) {
        const route = this.route.name;
        if (route) {
          route.toString().toUpperCase();
        }
        this.navigationItems.forEach((item) => {
          if (item.module == route) {
            this.selectedItem = item;
          }
        })
      }
      return res;
    }
  },

  methods: {
    getClass(navItem: NavigationItem): string {
      let res = navItem.picto;
      if (navItem == this.selectedItem) {
        res += "Active";
      }
      return res;
    },
    pushModuleRoute(navItem: NavigationItem) {
      if (event != undefined) {
        event.stopPropagation();
      }
      this.selectedItem = navItem;
      if (navItem.route != null) {
        goToModule(this.router, navItem.route);
      }
    }
  }
})

</script>
